import { CloseOutlined } from '@ant-design/icons'
import { Button, Col, Row } from 'antd'
import { StyledSearch } from 'components/GlobalStyles'
import Link from 'next/link'
import { FaSearch } from 'react-icons/fa'
import ViewContainer from './container'
import { StyledSearchBarWrapper } from './styles'

export default function Index () {
  return (
    <ViewContainer>
      {({ handleSearch }) => (
        <Row>
          <Col xs={{ span: 0 }} md={{ span: 24 }}>
            <StyledSearchBarWrapper>
              <h1>Find exactly what you’re looking for.</h1>
              <StyledSearch
                prefix={<FaSearch />}
                onKeyDown={(e) => handleSearch(e)}
              />
            </StyledSearchBarWrapper>
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 0 }}>
            <StyledSearchBarWrapper>
              <StyledSearch
                prefix={<FaSearch />}
                onKeyDown={(e) => handleSearch(e)}
              />
              <Link href='/'>
                <Button shape='circle' icon={<CloseOutlined /> } />
              </Link>
            </StyledSearchBarWrapper>
          </Col>
        </Row>
      )}
    </ViewContainer>
  )
}
